import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000'

// The one place the browser's access token is read, written and refreshed.
// Previously three API clients each kept their own copy of the refresh logic,
// and two of them preferred a second storage key ('goodday_token') that only
// one client ever refreshed - a stale value there overrode the fresh 'token'
// and every request failed with "Authorization token expired".
const TOKEN_KEY = 'token'
const LEGACY_TOKEN_KEY = 'goodday_token'

try {
  localStorage.removeItem(LEGACY_TOKEN_KEY)
} catch {}

export function getAccessToken(): string | null {
  try {
    return typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null
  } catch {
    return null
  }
}

export function setAccessToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearAccessToken() {
  localStorage.removeItem(TOKEN_KEY)
}

let inflight: Promise<string> | null = null

/**
 * Exchanges the httpOnly refresh cookie for a new access token. Concurrent
 * callers share one request, so a burst of 401s triggers a single refresh.
 */
export function refreshAccessToken(): Promise<string> {
  if (!inflight) {
    inflight = axios
      .post<{ accessToken: string }>(`${API_URL}/api/v1/goodday/auth/refresh`, {}, { withCredentials: true })
      .then((res) => {
        const token = res.data?.accessToken
        if (!token) throw new Error('No access token in refresh response')
        setAccessToken(token)
        return token
      })
      .finally(() => {
        inflight = null
      })
  }
  return inflight
}
